export default __webpack_public_path__ + "c342c3de1c227b446f55443a7290d432.png";